module.exports = __webpack_public_path__ + "static/media/woocommerce-connected.6e84fc98.svg";